import { EditorState, convertToRaw } from 'draft-js';

const convert = (editorState: EditorState) => {
  return JSON.stringify(convertToRaw(editorState.getCurrentContent()));
};

export default convert;
